import $ from 'jquery';

function searchFaq() {
    const sPhrase = $('.control--faq-search input').val();
    const $questions = $('.faq-item__question');
    const $groups = $('.faq-block');

    if (sPhrase !== '') {
        $groups.hide();
        $questions.hide();
        $(`.faq-item__question:contains(${sPhrase})`).each(function () {
            $(this).show().closest('.faq-block').show();
        });
    } else {
        $groups.show();
        $questions.show();
    }
}

$('body').on('submit', '.faq-search', function (e) {
    e.preventDefault();
    searchFaq();
});

searchFaq();
